import React, { useContext, useEffect, useState } from "react";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { Select } from "../../../../assets/css/components/admin/products/ShowProductInfo/ShowProductInfo.css";
import handleAxiosError from "../../update-and-publish/functions/handleAxiosError";
import axios from "axios";
import {
  keyAccessToken,
  keyUserId,
} from "../../../../assets/js/SessionStorageNames";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import { downloadCategoriesVtex, syncProductsVtex, updateProductsVtex } from "../../../../hooks/api/vtex";
import InstapagoCredentials from "./InstapagoCredentials";
import { createBankInfo, getBankInfoByEnterprise, updateBankInfo } from "../../../../hooks/api/instapago";
import ListOfProductsToSetParams from "../../../../assets/css/components/admin/marketplace-to-marketplace/products/ListOfProductsToSetParams";

export default function View({ username, step = 2, listUsers }) {
  const [loading, setLoading] = useState(false);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [tarifas, setTarifas] = useState([]);
  const [tarifaSelected, setTarifaSelected] = useState(null);
  const globalContext = useContext(GlobalContext);
  const [skuId, setSkuId] = useState(null);
  const [modalNewBankInfo, setModalNewBankInfo] = useState(false);
  const [modalEditBankInfo, setModalEditBankInfo] = useState(false);
  const [bankData, setBankData] = useState({
    name: "",
    serialNumber: "",
    bankAccount: "",
    telephone: "",
    rif: "",
    odooJournalId: "",
    active: true,
  });
  const [editingBankId, setEditingBankId] = useState(null);
  const [banksList, setBanksList] = useState([]);

  const changeTarifa = (t) => {
    setTarifaSelected(t);
    console.log(t);
  };


  const donwloadCategories = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      console.log('username')
      console.log(entId)
      console.log(username)
      console.log('username')
      const resp = await downloadCategoriesVtex(entId, username)
      console.log('se ejecuto', resp)
      if(resp?.data?.message) await globalContext.showModalWithMsg('Se ha iniciado la descarga de categorias en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al descargar las productos.');
    }
}

  const syncProducts = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      const resp = await syncProductsVtex(entId, username)
      if(resp?.message) await globalContext.showModalWithMsg('Se ha iniciado el proceso de sincronización de productos en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al sincronizar los productos.');
    }
  }
  const updateProducts = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      console.log(skuId, 'sku')
      const resp = await updateProductsVtex(entId, username, skuId)
      if(resp?.message) await globalContext.showModalWithMsg('Se ha iniciado el proceso de sincronización de productos en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al sincronizar los productos.');
    }
  }
  /**
   * Function to consult the lists of available rates
   */
  async function getPriceList() {
    const entId = await globalContext.currentEnterpriseId;
    const url = `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`;
    if (entId)
      await axios
        .get(url, {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        })
        .then((resp) => {
          const data = resp.data.data;
          setTarifas(data.priceLists);
          console.log(data.priceLists);
        })
        .catch((err) => {
          console.log(err);
          handleAxiosError(
            err,
            "Disculpe, no se pudo cargar la lista de tarifas."
          );
        });
  }

  useEffect(() => {
    getPriceList();
  }, [globalContext.currentEnterpriseId]);

  const loadBanks = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      if (!entId) return;
      const response = await getBankInfoByEnterprise(entId);
      if (response && response.data && response.data.bankInfos) {
        setBanksList(response.data.bankInfos);
      }
    } catch (error) {
      console.error("Error al cargar bancos", error);
      setBanksList([]);
    }
  };

  useEffect(() => {
    if (step === 3 && globalContext.currentEnterpriseId) {
      loadBanks();
    }
  }, [step, globalContext.currentEnterpriseId]);

  return (
    <>
      {step === 2 ? (
        <>
          <PedidosYaStyle.ContForm style={{ marginTop: 55 }}>
            <PedidosYaStyle.HeaderForm>
              <PedidosYaStyle.Text size="14pt" fw="500" cl="#898989">
                Operaciones de Instapago ({username})
              </PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm>
              {/* <div style={{ display: "flex", justifyContent: "center" }}>
                <PedidosYaStyle.ContInputAndLabel
                  w="50%"
                  colSpan="1"
                  style={{ marginTop: 40 }}
                >
                  <PedidosYaStyle.Text
                    size="12pt"
                    style={{ textAlign: "center" }}
                  >
                    <strong>Tarifas Disponibles</strong>
                  </PedidosYaStyle.Text>
                  <div className="d-flex justify-content-center">
                    <Select
                      className="tarifa"
                      onChange={(e) => {
                        changeTarifa(e.target.value);
                      }}
                    >
                      <option selected>SELECCIONE UNA TARIFA</option>
                      {tarifas.map((val, i) => (
                        <option key={i} name="tarifa" value={val.name}>
                          {val.name}
                        </option>
                      ))}
                    </Select>
                    <PedidosYaStyle.BtnSend
                      //   onClick={}
                      style={{ width: "100%", textAlign: "center" }}
                    >
                      {loading ? "Espere" : "Actualizar"}
                    </PedidosYaStyle.BtnSend>
                  </div>
                </PedidosYaStyle.ContInputAndLabel>
              </div> */}
              <PedidosYaStyle.ContInputAndLabel
                w="50%"
                colSpan="2"
                style={{ margin: "auto", marginTop: 30 }}
              >
                <PedidosYaStyle.Text
                  size="12pt"
                  style={{ textAlign: "center" }}
                >
                  <strong>Sincronizar</strong>
                </PedidosYaStyle.Text>
                <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                  <PedidosYaStyle.BtnSend
                    onClick={syncProducts}
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    {loading ? "Espere" : "Sincronizar todos los productos"}
                  </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.ContInputButtonGroup>
              </PedidosYaStyle.ContInputAndLabel>
              {/* <PedidosYaStyle.ContInputAndLabel
                w="50%"
                colSpan="2"
                style={{ margin: "auto", marginTop: 30 }}
              >
                <PedidosYaStyle.Text
                  size="12pt"
                  style={{ textAlign: "center" }}
                >
                  <strong>Actualizar productos por SkuId</strong>
                </PedidosYaStyle.Text>
                <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                  <PedidosYaStyle.Input value={skuId}
                  onChange={(v)=>setSkuId(v.target.value)}
                  />
                  <PedidosYaStyle.BtnSend
                    onClick={updateProducts}
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    {loading ? "Espere" : "Actualizar productos"}
                  </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.ContInputButtonGroup>
              </PedidosYaStyle.ContInputAndLabel> */}

              <PedidosYaStyle.ContInputAndLabel
                w="50%"
                colSpan="2"
                style={{ margin: "auto", marginTop: 25 }}
              >
                <PedidosYaStyle.Text
                  size="12pt"
                  style={{ textAlign: "center" }}
                >
                </PedidosYaStyle.Text>
                <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                  <PedidosYaStyle.BtnSend
                    onClick={donwloadCategories}
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    {loading ? "Espere" : "Descargar Categorias"}
                  </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.ContInputButtonGroup>
              </PedidosYaStyle.ContInputAndLabel>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </>
      ) : step === 3 ? (
        <>
          <PedidosYaStyle.ContForm style={{ marginTop: 55 }}>
            <PedidosYaStyle.HeaderForm>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <PedidosYaStyle.Text size="14pt" fw="500" cl="#898989">
                  Gestión de Bancos
                </PedidosYaStyle.Text>
                <PedidosYaStyle.BtnSend onClick={() => {
                  setBankData({ name: "", serialNumber: "", bankAccount: "", telephone: "", rif: "", odooJournalId: "", active: true });
                  setModalNewBankInfo(true);
                }} style={{ padding: "8px 16px", fontSize: "12pt" }}>
                  + Nuevo Banco
                </PedidosYaStyle.BtnSend>
              </div>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm>
              {banksList.length === 0 ? (
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2" style={{ margin: "auto", marginTop: 30 }}>
                  <PedidosYaStyle.Text size="12pt" style={{ textAlign: "center" }}>
                    No hay bancos registrados. Crea uno nuevo para comenzar.
                  </PedidosYaStyle.Text>
                </PedidosYaStyle.ContInputAndLabel>
              ) : (
                <PedidosYaStyle.ContTable style={{ marginTop: 20 }}>
                  <PedidosYaStyle.HeaderContTable>
                    <PedidosYaStyle.Text size="14pt" fw="500">
                      Bancos Registrados ({banksList.length})
                    </PedidosYaStyle.Text>
                  </PedidosYaStyle.HeaderContTable>
                  <PedidosYaStyle.TableResult>
                    <PedidosYaStyle.TableResultThead>
                      <tr>
                        <PedidosYaStyle.TableResultTh width="20%">Nombre</PedidosYaStyle.TableResultTh>
                        <PedidosYaStyle.TableResultTh width="15%">N° Serie</PedidosYaStyle.TableResultTh>
                        <PedidosYaStyle.TableResultTh width="20%">Cuenta</PedidosYaStyle.TableResultTh>
                        <PedidosYaStyle.TableResultTh width="15%">RIF</PedidosYaStyle.TableResultTh>
                        <PedidosYaStyle.TableResultTh width="10%">Estado</PedidosYaStyle.TableResultTh>
                        <PedidosYaStyle.TableResultTh width="20%">Acciones</PedidosYaStyle.TableResultTh>
                      </tr>
                    </PedidosYaStyle.TableResultThead>
                    <PedidosYaStyle.TableResultTbody>
                      {banksList.map((bank) => (
                        <PedidosYaStyle.TableResultTr key={bank._id}>
                          <PedidosYaStyle.TableResultTd>{bank.name}</PedidosYaStyle.TableResultTd>
                          <PedidosYaStyle.TableResultTd>{bank.serialNumber}</PedidosYaStyle.TableResultTd>
                          <PedidosYaStyle.TableResultTd>{bank.bankAccount}</PedidosYaStyle.TableResultTd>
                          <PedidosYaStyle.TableResultTd>{bank.rif}</PedidosYaStyle.TableResultTd>
                          <PedidosYaStyle.TableResultTd>
                            <span style={{ 
                              padding: "4px 8px", 
                              borderRadius: "4px", 
                              fontSize: "10pt",
                              backgroundColor: bank.active ? "#28a745" : "#dc3545",
                              color: "white"
                            }}>
                              {bank.active ? "Activo" : "Inactivo"}
                            </span>
                          </PedidosYaStyle.TableResultTd>
                          <PedidosYaStyle.TableResultTd>
                            <PedidosYaStyle.BtnSend 
                              onClick={() => {
                                setEditingBankId(bank._id);
                                setBankData({
                                  name: bank.name || "",
                                  serialNumber: bank.serialNumber || "",
                                  bankAccount: bank.bankAccount || "",
                                  telephone: bank.telephone || "",
                                  rif: bank.rif || "",
                                  odooJournalId: bank.odooJournalId || "",
                                  active: bank.active !== undefined ? bank.active : true,
                                });
                                setModalEditBankInfo(true);
                              }}
                              style={{ padding: "4px 12px", fontSize: "11pt", marginRight: "5px" }}
                            >
                              Editar
                            </PedidosYaStyle.BtnSend>
                          </PedidosYaStyle.TableResultTd>
                        </PedidosYaStyle.TableResultTr>
                      ))}
                    </PedidosYaStyle.TableResultTbody>
                  </PedidosYaStyle.TableResult>
                </PedidosYaStyle.ContTable>
              )}
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </>
      ) : (
        <>
          <InstapagoCredentials username={username} loading={loading} setLoading={setLoading} listUsers={listUsers} />
        </>
      )}
      
      {/* Modal para crear nueva información de banco */}
      {modalNewBankInfo && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh", position: "fixed", top: 0, left: 0, backgroundColor: "rgba(92, 92, 92, 0.39)", zIndex: 1000 }}>
          <PedidosYaStyle.ContForm style={{ position: "absolute", maxWidth: 700, margin: "auto", width: "100%", maxHeight: "90vh", overflowY: "auto" }}>
            <ListOfProductsToSetParams.Close style={{ top: 10, right: 10 }} onClick={() => setModalNewBankInfo(false)} />
            <PedidosYaStyle.HeaderForm>
              <PedidosYaStyle.Text size="14pt">Crear nueva información de banco</PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm>
              <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2" style={{ marginTop: 10 }}>
                  <PedidosYaStyle.Text size="12pt"><strong>Nombre del banco *</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="name" value={bankData.name} placeholder="Ej: Banco de Venezuela" onChange={(e) => setBankData({...bankData, name: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>Número de serie *</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input type="number" name="serialNumber" value={bankData.serialNumber} placeholder="123" onChange={(e) => setBankData({...bankData, serialNumber: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>Número de cuenta bancaria *</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="bankAccount" value={bankData.bankAccount} placeholder="00001234567890123456789" onChange={(e) => setBankData({...bankData, bankAccount: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>Teléfono *</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="telephone" value={bankData.telephone} placeholder="+58-212-1234567" onChange={(e) => setBankData({...bankData, telephone: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>RIF *</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="rif" value={bankData.rif} placeholder="J-12345678-9" onChange={(e) => setBankData({...bankData, rif: e.target.value.toUpperCase()})} style={{ textTransform: "uppercase" }} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>ID del diario Odoo *</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input type="number" name="odooJournalId" value={bankData.odooJournalId} placeholder="123" onChange={(e) => setBankData({...bankData, odooJournalId: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input type="checkbox" name="active" checked={bankData.active} onChange={(e) => setBankData({...bankData, active: e.target.checked})} style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                    <PedidosYaStyle.Text size="12pt"><strong>Activo</strong></PedidosYaStyle.Text>
                  </div>
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2" style={{ marginTop: 20 }}>
                  <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                    <PedidosYaStyle.BtnSend onClick={async () => {
                      setLoading(true);
                      try {
                        const entId = globalContext.currentEnterpriseId;
                        const dataToSend = {
                          name: bankData.name.trim(),
                          serialNumber: parseInt(bankData.serialNumber),
                          bankAccount: bankData.bankAccount.trim(),
                          telephone: bankData.telephone.trim(),
                          rif: bankData.rif.trim().toUpperCase(),
                          odooJournalId: parseInt(bankData.odooJournalId),
                          active: bankData.active,
                          enterpriseId: entId,
                        };
                        await createBankInfo(entId, dataToSend);
                        await globalContext.showModalWithMsg(`Información del banco "${bankData.name}" creada exitosamente.`);
                        setBankData({ name: "", serialNumber: "", bankAccount: "", telephone: "", rif: "", odooJournalId: "", active: true });
                        setModalNewBankInfo(false);
                        await loadBanks();
                      } catch (err) {
                        const errorMessage = err?.response?.data?.message || err?.message || "Error al crear la información del banco";
                        await globalContext.showModalWithMsg(`Error: ${errorMessage}`);
                      } finally {
                        setLoading(false);
                      }
                    }} style={{ width: "100%", textAlign: "center" }} disabled={loading}>
                      {loading ? "Creando..." : "Crear banco"}
                    </PedidosYaStyle.BtnSend>
                  </PedidosYaStyle.ContInputButtonGroup>
                </PedidosYaStyle.ContInputAndLabel>
              </div>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </div>
      )}
      
      {/* Modal para editar información de banco */}
      {modalEditBankInfo && editingBankId && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh", position: "fixed", top: 0, left: 0, backgroundColor: "rgba(92, 92, 92, 0.39)", zIndex: 1000 }}>
          <PedidosYaStyle.ContForm style={{ position: "absolute", maxWidth: 700, margin: "auto", width: "100%", maxHeight: "90vh", overflowY: "auto" }}>
            <ListOfProductsToSetParams.Close style={{ top: 10, right: 10 }} onClick={() => {
              setModalEditBankInfo(false);
              setEditingBankId(null);
              setBankData({ name: "", serialNumber: "", bankAccount: "", telephone: "", rif: "", odooJournalId: "", active: true });
            }} />
            <PedidosYaStyle.HeaderForm>
              <PedidosYaStyle.Text size="14pt">Editar información de banco</PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm>
              <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2" style={{ marginTop: 10 }}>
                  <PedidosYaStyle.Text size="12pt"><strong>Nombre del banco</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="name" value={bankData.name} placeholder="Ej: Banco de Venezuela" onChange={(e) => setBankData({...bankData, name: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>Número de serie</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input type="number" name="serialNumber" value={bankData.serialNumber} placeholder="123" onChange={(e) => setBankData({...bankData, serialNumber: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>Número de cuenta bancaria</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="bankAccount" value={bankData.bankAccount} placeholder="00001234567890123456789" onChange={(e) => setBankData({...bankData, bankAccount: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>Teléfono</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="telephone" value={bankData.telephone} placeholder="+58-212-1234567" onChange={(e) => setBankData({...bankData, telephone: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>RIF</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input name="rif" value={bankData.rif} placeholder="J-12345678-9" onChange={(e) => setBankData({...bankData, rif: e.target.value.toUpperCase()})} style={{ textTransform: "uppercase" }} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <PedidosYaStyle.Text size="12pt"><strong>ID del diario Odoo</strong></PedidosYaStyle.Text>
                  <PedidosYaStyle.Input type="number" name="odooJournalId" value={bankData.odooJournalId} placeholder="123" onChange={(e) => setBankData({...bankData, odooJournalId: e.target.value})} />
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2">
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input type="checkbox" name="active" checked={bankData.active} onChange={(e) => setBankData({...bankData, active: e.target.checked})} style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                    <PedidosYaStyle.Text size="12pt"><strong>Activo</strong></PedidosYaStyle.Text>
                  </div>
                </PedidosYaStyle.ContInputAndLabel>

                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="2" style={{ marginTop: 20 }}>
                  <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                    <PedidosYaStyle.BtnSend onClick={async () => {
                      setLoading(true);
                      try {
                        const dataToSend = {};
                        if (bankData.name) dataToSend.name = bankData.name.trim();
                        if (bankData.serialNumber) dataToSend.serialNumber = parseInt(bankData.serialNumber);
                        if (bankData.bankAccount) dataToSend.bankAccount = bankData.bankAccount.trim();
                        if (bankData.telephone) dataToSend.telephone = bankData.telephone.trim();
                        if (bankData.rif) dataToSend.rif = bankData.rif.trim().toUpperCase();
                        if (bankData.odooJournalId) dataToSend.odooJournalId = parseInt(bankData.odooJournalId);
                        dataToSend.active = bankData.active;
                        
                        await updateBankInfo(globalContext.currentEnterpriseId, editingBankId, dataToSend);
                        await globalContext.showModalWithMsg(`Información del banco actualizada exitosamente.`);
                        setBankData({ name: "", serialNumber: "", bankAccount: "", telephone: "", rif: "", odooJournalId: "", active: true });
                        setModalEditBankInfo(false);
                        setEditingBankId(null);
                        await loadBanks();
                      } catch (err) {
                        const errorMessage = err?.response?.data?.message || err?.message || "Error al actualizar la información del banco";
                        await globalContext.showModalWithMsg(`Error: ${errorMessage}`);
                      } finally {
                        setLoading(false);
                      }
                    }} style={{ width: "100%", textAlign: "center" }} disabled={loading}>
                      {loading ? "Actualizando..." : "Actualizar banco"}
                    </PedidosYaStyle.BtnSend>
                  </PedidosYaStyle.ContInputButtonGroup>
                </PedidosYaStyle.ContInputAndLabel>
              </div>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </div>
      )}
    </>
  );
}
